import { OfferSummaryCard, createOfferSummaryCard } from '@vfde-brix/ws10/offer-summary-card';
import { HtmlId } from '../enum';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { CmsSummaryCard } from '../interface';
import { ProductContainerActions, ProductContainerProps } from '../container/Product';
import summaryCardUtils from '../util/component/summaryCard.utils';

export const mountSummaryCard = (id: HtmlId) =>
    createComponentById(createOfferSummaryCard, id, NO_PATTERN_BUSINESS_LOGIC);

export const updateSummaryCardButton = (
    comp: OfferSummaryCard | null,
    stateProps: ProductContainerProps,
    cmsProps: CmsSummaryCard,
    actions: ProductContainerActions,
) => {
    if (!comp) {
        return;
    }

    const props = comp.getProperties();

    if (!props.containerButtons || !props.containerButtons.length) {
        return;
    }

    const [ button ] = props.containerButtons;

    button.business.onClick = summaryCardUtils.getButtonAction(stateProps, actions);
    button.linkHref = summaryCardUtils.getButtonLink(stateProps, cmsProps.button);
    button.stdContent = summaryCardUtils.getButtonText(stateProps, cmsProps.button);

    comp.updateButtons([ button ]);
};

export const updateSummaryCardContent = (
    comp: OfferSummaryCard | null,
    stateProps: ProductContainerProps,
    cmsProps: CmsSummaryCard,
) => {
    if (!comp) {
        return;
    }

    const props = comp.getProperties();

    if (!props.containerHeadline) {
        return;
    }

    props.containerHeadline.stdContent = summaryCardUtils.getHeadlineText(stateProps, cmsProps.headline);
    props.txtSubline = summaryCardUtils.getSublineText(stateProps, cmsProps.subline);
    props.txtLegalText = summaryCardUtils.getLegalText(stateProps, cmsProps.legalText);
    props.txtAdditionalText = summaryCardUtils.getAdditionalTexts(stateProps, cmsProps.additionalText);

    comp.updateHeadline(props.containerHeadline);
    comp.updateSubline(props.txtSubline);
    comp.updateLegalText(props.txtLegalText);
    comp.updateAdditionalText(props.txtAdditionalText);
};

export const updateSummaryCardPrices = (
    comp: OfferSummaryCard | null,
    stateProps: ProductContainerProps,
    cmsProps: CmsSummaryCard,
) => {
    if (!comp || !stateProps.product) {
        return;
    }

    const props = comp.getProperties();
    const shouldShow = !stateProps.hasTvContract && !stateProps.isNonMonthlyBilling && !stateProps.isBookingDisabled;

    if (!props.containerPromoPrices || !props.containerAdditionalPrices) {
        return;
    }

    const [ promoPrice ] = props.containerPromoPrices;
    const price = summaryCardUtils.getPrice(stateProps);

    if (price) {
        promoPrice.containerPromoPrice.price = price;
        promoPrice.containerPromoPrice.strikePrice = undefined;
    }

    props.containerAdditionalPrices = summaryCardUtils.getAdditionalPrices(stateProps, cmsProps.additionalPrice);

    comp.updatePrices(props.containerPromoPrices, props.containerAdditionalPrices);
    comp.toggleMiddleContentContainer(shouldShow);
};
